import {
  SET_DATA,
  SET_TASKS,
  SET_PROJECTPLAN,
  SET_INVOICES,
  SET_ATTACHMENTS,
  SET_TRIAGE,
} from "./types";
import { initialState } from "../state";
import { DataActionType } from "./types";

const data = (state = initialState.data, action: DataActionType) => {
  switch (action.type) {
    case SET_DATA:
      return {
        ...state,
        rowData: [...action.data],
      };

    case SET_TASKS:
      return {
        ...state,
        tasks: [...action.data],
      };

    case SET_PROJECTPLAN:
      return {
        ...state,
        projectPlan: [...action.data],
      };

    case SET_INVOICES:
      return {
        ...state,
        invoices: [...action.data],
      };

    case SET_ATTACHMENTS:
      return {
        ...state,
        attachments: [...action.data],
      };

    case SET_TRIAGE:
      return {
        ...state,
        triageDetails: action.data,
      };

    default:
      return state;
  }
};

export default data;
